import $http from '../../axios-instance';
import Swal from 'sweetalert2';

/**
 * Obtener proveedores
 */
export async function fetchProviders({commit, state, rootState}, reset_page = false) {

    commit('dashboard/load', true, {root: true});

    commit('setCompanyIdToParams', rootState.empresa.selectedEmpresa.id)

    if (reset_page) {
        commit('setPageToParams', 1);
    }

    await $http.get('providers', {params: state.params})
        .then((response) => {
            commit('setProviders', response.data.data);
            commit('dashboard/load', false, {root: true});
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener proveedor.
 */
export async function getProvider({commit, state}, id) {

    commit('dashboard/load', true, {root: true});

    await $http.get(`providers/${id}`)
        .then((response) => {
            commit('setProvider', response.data.data);
            commit('dashboard/load', false, {root: true});
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Crear proveedor.
 */
export async function createProvider({commit, state}) {

    commit('dashboard/load', true, {root: true});

    await $http.post(`providers`, state.provider)
        .then((response) => {
            commit('resetProvider');
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien',
                text: response.data.message,
                showConfirmButton: false,
                timer: 1500
            });
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: 'Error al actualizar el proveedor',
                showConfirmButton: false,
                timer: 1500
            });
        });
}

/**
 * Asociar empresa a proveedor.
 */
export async function createCompanyProvider({commit, state}, data) {

    commit('dashboard/load', true, {root: true});

    await $http.post(`company-providers`, data)
        .then((response) => {
            commit('fecthProviders');
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien',
                text: response.data.message,
                showConfirmButton: false,
                timer: 1500
            });
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: 'Error al actualizar el proveedor',
                showConfirmButton: false,
                timer: 1500
            });
        });
}

/**
 * Actualizar proveedor.
 */
export async function updateProvider({commit, state}) {

    commit('dashboard/load', true, {root: true});

    await $http.put(`providers/${state.provider.id}`, state.provider)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien',
                text: response.data.message,
                showConfirmButton: false,
                timer: 1500
            });
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: 'Error al actualizar el proveedor',
                showConfirmButton: false,
                timer: 1500
            });
        });
}

/**
 * Eliminar proveedor.
 */
export async function deleteProvider({commit, state, dispatch}, id) {

    await Swal.fire({
        title: 'Eliminar',
        text: 'Esta seguro de eliminar el proveedor?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Si',
    }).then(async (result) => {
        if (result.value) {
            commit('dashboard/load', true, {root: true});

            await $http.delete(`providers/${id}`)
                .then((response) => {
                    commit('dashboard/load', false, {root: true});
                    dispatch('fetchProviders');
                    Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'Muy bien',
                        text: response.data.message,
                        showConfirmButton: false,
                        timer: 1500
                    });
                })
                .catch((error) => {
                    commit('dashboard/load', false, {root: true});
                    Swal.fire({
                        position: 'center',
                        icon: 'error',
                        title: 'Error',
                        text: 'Error al actualizar el proveedor',
                        showConfirmButton: false,
                        timer: 1500
                    });
                });
        }
    });
}

/**
 * Obtener las fuentes de peligro.
 */
export async function fetchIdentificationTypes({dispatch, commit, state}) {
    commit('dashboard/load', true, {root: true});

    await $http.get(`/lists/TIID1`)
        .then((response) => {
            commit('setIdentificationTypes', response.data.data);
            commit('dashboard/load', false, {root: true});
        }).catch(() => {
            commit('dashboard/load', false, {root: true});
        });
}
